import {
    handleQueryResolve,
    buildMapToField
} from '../utils';

export default function(query, attrs = []){
    return this.query(query, attrs).then(handleQueryResolve)
        .then((records) => {
            try {
                // only if its an array
                if (Array.isArray(records)) {
                    return records.map(record => buildMapToField(record));
                }
                // its an object
                if (Object.keys(records).length) {
                    return buildMapToField(records);
                }
            } catch (e) { // if its none of array or object
                return records;
            }
        });
}